<div class="scroll-buttons-container space-children-row small-space flex-row align-items-center">
    <button class="btn ghost-button scroll-button" (click)="scrollLeft()" [disabled]="isLeftDisabled">
        <i class="icon icon-caret-left"></i>
    </button>
    <button class="btn ghost-button scroll-button" (click)="scrollRight()" [disabled]="isRightDisabled">
        <i class="icon icon-caret-right"></i>
    </button>
</div>
